<div class="container-button-scroll">
    <button type="button" class="button-scroll" (click)="ElementFocus('acticletContainer')"><i class="fa-solid fa-angle-down"></i><p>SCROLL DOWN TO LEARN MORE</p></button>
</div>
<div class="text-articles-container" id="acticletContainer">
    
    <div *ngFor="let article of articlesContent; index as i">
        <div [ngSwitch]="article.fields.distributionType">  
            <div class="article-container" *ngSwitchCase="'Text ⭢ Image'">
                <div class="article">
                    <div class="title-article">{{ article.fields.title }}</div>                    
                    <div class="text-article">
                        <div [innerHTML]="article.fields.textArticle | safeString | mdToHtml">                            
                        </div>
                    </div>
                </div>            
                <div class="image-container" *ngFor="let image of getImageArray(article.fields.image); index as ii">
                    <img *ngIf="image.fields.file?.url" [src]="image.fields.file?.url">
                </div>
           </div>
       </div>
    </div>
</div>